import React, { useState } from "react";
import styled from "styled-components";
import {
    Button,
    LottieLoadingIndicator,
    StandardModal,
    StandardModalActionGroup,
    StandardModalDescription,
    StandardModalFormGroup,
    StandardModalSection,
    StandardModalSectionTitle,
    Toast,
    FormField
} from "src/components";
import { updateCustomMyQuotesName } from "../../components/api";
import { DefaultMyQuotesFeatureName } from "../../Myquotes";

const StyledTitleInput = styled(FormField)`
    border: 1px solid #8291b2;
    border-radius: 12px;
    text-align: left;
    font-family: Manrope, Helvetica, sans-serif;
    font-weight: 400;
    font-size: 1rem;
    color: #000;
    width: 364px;
    max-width: 100%;
    height: 50px;
    box-shadow: none;

    ::placeholder {
        text-align: left;
        color: #808080;
        font-family: Manrope, Helvetica, sans-serif;
    }
`;

export default function ChangeNameDialog(props) {
    const { hideShowNameChangeDialog, featureName, setFeatureName } = props;
    const [isLoading, setIsLoading] = useState(false);
    const [customName, setCustomName] = useState(featureName);

    const onSubmit = async () => {
        setIsLoading(true);
        try {
            const response = await updateCustomMyQuotesName(customName);
            setFeatureName(response.customName || DefaultMyQuotesFeatureName);
            hideShowNameChangeDialog();
        } catch (error) {
            console.log(error);
            Toast.error(error.getApiErrorDetails().message);
        } finally {
            setIsLoading(false);
        }
    };

    if (isLoading) {
        return (
            <StandardModal
                open={true}
                onClose={hideShowNameChangeDialog}
                title="Change Quotes Feature Name"
                widthMode="medium"
            >
                <LottieLoadingIndicator/>
            </StandardModal>
        );
    }

    return (
        <StandardModal
            open={true}
            onClose={hideShowNameChangeDialog}
            title="Change Quotes Feature Name"
            description="Rename the Quotes feature in the Me Business app and portal to better match your business or community."
            widthMode="medium"
            footer={(
                <StandardModalActionGroup $pushRight>
                    <Button
                        type="button"
                        onClick={() => hideShowNameChangeDialog()}
                        size="0.875rem"
                        border="1px solid #000"
                        color="#000"
                        width="8.75rem"
                        style={{ borderRadius: "7px", boxShadow: "none" }}
                    >
                        Cancel
                    </Button>
                    <Button
                        type="submit"
                        backgroundColor="#171A22"
                        border="1px solid #171A22"
                        color="#fff"
                        width="8.75rem"
                        style={{ borderRadius: "7px", boxShadow: "none" }}
                        onClick={() => onSubmit()}
                    >
                        Save
                    </Button>
                </StandardModalActionGroup>
            )}
        >
            <StandardModalSection>
                <StandardModalFormGroup>
                    <StandardModalSectionTitle>Set a Custom Name (Optional)</StandardModalSectionTitle>
                    <StandardModalDescription>
                        Enter a new name for this feature. If left blank, it will continue to appear as ‘Quotes’.
                    </StandardModalDescription>
                    <StyledTitleInput
                        name="CustomQuotesName"
                        value={customName}
                        placeholder="e.g. Daily Inspiration"
                        onChange={(e) => setCustomName(e.target.value || "")}
                    />
                </StandardModalFormGroup>
            </StandardModalSection>
        </StandardModal>
    );
}
